import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../libs/axios';

interface UpdateOrdemTrabalhoParams {
  pedidoId: string;
  ordemTrabalho: string;
}

export function useOrdemTrabalho() {
  const queryClient = useQueryClient();

  const updateOrdemTrabalho = useMutation({
    mutationFn: async ({ pedidoId, ordemTrabalho }: UpdateOrdemTrabalhoParams) => {
      const response = await api.patch(`/pedidos/${pedidoId}/ordem-trabalho`, {
        ordem_trabalho: ordemTrabalho
      });
      return response.data;
    },
    onSuccess: (_, variables) => {
      // Invalida a query do pedido para refletir as mudanças
      queryClient.invalidateQueries({ 
        queryKey: ['pedido', variables.pedidoId] 
      });
    },
    onError: (error) => {
      console.error('Erro ao atualizar ordem de trabalho:', error);
    }
  });

  return {
    updateOrdemTrabalho: updateOrdemTrabalho.mutate,
    isUpdating: updateOrdemTrabalho.isPending,
    error: updateOrdemTrabalho.error
  };
}
